
export const editDistance = function (s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();
    var costs = [];
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i === 0)
                costs[j] = j;
            else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) !== s2.charAt(j - 1))
                        newValue = Math.min(Math.min(newValue, lastValue),
                            costs[j]) + 1;
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0)
            costs[s2.length] = lastValue;
    }
    return costs[s2.length];
};


/**
 *
 * @param {String} s1
 * @param {String} s2
 * @returns {number}
 */
export const similarText = function (s1, s2) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength === 0) {
        return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
};


/**
 * @see https://stackoverflow.com/a/53681022/9267815
 * @param string
 * @returns {string}
 */
export const removeNonASCIICharacters = function (string) {
    return String(string).replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, "");
};


/**
 * Sprawdza czy string przypomina adres email
 * @param {string} emailAddress
 * @returns {boolean}
 */
export const isEmailAddress = function (emailAddress) {
    return String(emailAddress).match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi) !== null;
};
